module.exports = __webpack_public_path__ + "img/otoformicon2.e4e87d0d.png";